function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 2.667C8.64 2.667 2.666 8.64 2.666 16S8.64 29.333 16 29.333c7.36 0 13.333-5.973 13.333-13.333S23.36 2.667 16 2.667zm-2.667 20L6.666 16l1.88-1.88 4.787 4.773 10.12-10.12 1.88 1.894-12 12z"
});

var SvgCircleCheck3 = function SvgCircleCheck3(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 32 32",
    fill: "#50BD8E"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 32 32' fill='%2350BD8E' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M15.9998 2.66663C8.63984 2.66663 2.6665 8.63996 2.6665 16C2.6665 23.36 8.63984 29.3333 15.9998 29.3333C23.3598 29.3333 29.3332 23.36 29.3332 16C29.3332 8.63996 23.3598 2.66663 15.9998 2.66663ZM13.3332 22.6666L6.6665 16L8.5465 14.12L13.3332 18.8933L23.4532 8.77329L25.3332 10.6666L13.3332 22.6666Z'/%3E %3C/svg%3E";
export { SvgCircleCheck3 as ReactComponent };